import { useTranslation } from 'react-i18next';
import {
  useGetEmailRule,
  useGetFullNameRule,
  useGetPhoneRule,
  useGetRequiredRule,
  useGetIbanRule,
  useGetIpn,
  useGetTaxCodeRule,
} from '@/hooks';
import { PartnerFormFieldsNames } from '../helpers/types';

export const usePartnerFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const nameRule = useGetFullNameRule({ t });
  const email = useGetEmailRule({ t });
  const taxCodeRule = useGetTaxCodeRule({ t });
  const ipnRule = useGetIpn({ t });
  const phoneRule = useGetPhoneRule({ t });
  const ibanRule = useGetIbanRule({ t });

  return {
    [PartnerFormFieldsNames.TITLE]: [requiredRule],
    [PartnerFormFieldsNames.LEGAL_TYPE]: [requiredRule],
    [PartnerFormFieldsNames.FIRST_NAME]: [requiredRule, nameRule],
    [PartnerFormFieldsNames.MIDDLE_NAME]: [requiredRule, nameRule],
    [PartnerFormFieldsNames.LAST_NAME]: [requiredRule, nameRule],
    [PartnerFormFieldsNames.PHONE]: [requiredRule, phoneRule],
    [PartnerFormFieldsNames.EMAIL]: [requiredRule, email],
    [PartnerFormFieldsNames.TAX_CODE]: [requiredRule, taxCodeRule],
    [PartnerFormFieldsNames.IPN]: [requiredRule, ipnRule],
    drfo: [requiredRule, { pattern: /^\d{10}$/, message: t('validation_invalid_format') }],
    [PartnerFormFieldsNames.LEGAL_ADDRESS]: [{ ...requiredRule, whitespace: true }],
    [PartnerFormFieldsNames.PHYSICAL_ADDRESS]: [{ ...requiredRule, whitespace: true }],
    [PartnerFormFieldsNames.IBAN]: [ibanRule],
    [PartnerFormFieldsNames.SUBSCRIBER_FULL_NAME]: [requiredRule],
  };
};
